import { PixelBuffer } from "../pixel/PixelBuffer";
import type { Selection } from "../selection/Selection";
import type { Filter } from "./Filter";

export interface TilesParams {
  tileSize: number;
  offset: number;
  fill: "wrap" | "background";
}

function clamp8(v: number): number {
  return v < 0 ? 0 : v > 255 ? 255 : v;
}

export const Tiles: Filter<TilesParams> = {
  id: "tiles",
  displayName: "Tiles",
  defaultParams: { tileSize: 16, offset: 25, fill: "wrap" },

  apply(input: PixelBuffer, params: TilesParams, _selection: Selection | null): PixelBuffer {
    const w = input.width;
    const h = input.height;
    const out = new PixelBuffer(w, h, input.mode);
    const src = input.data;
    const dst = out.data;

    if (w === 0 || h === 0) { dst.set(src); return out; }

    const size = Math.max(2, Math.round(params.tileSize));
    const offset = params.offset;

    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        const o = (y * w + x) * 4;
        const tileX = Math.floor(x / size);
        const tileY = Math.floor(y / size);
        const shift = (tileX + tileY) % 2 === 0 ? offset : -offset;
        let sx = x + shift;

        if (params.fill === "wrap") {
          sx = ((sx % w) + w) % w;
        } else {
          sx = Math.max(0, Math.min(w - 1, sx));
        }

        const si = (y * w + Math.round(sx)) * 4;
        if (si >= 0 && si < src.length) {
          dst[o] = src[si]!; dst[o + 1] = src[si + 1]!; dst[o + 2] = src[si + 2]!; dst[o + 3] = src[si + 3]!;
        } else {
          dst[o] = src[o]!; dst[o + 1] = src[o + 1]!; dst[o + 2] = src[o + 2]!; dst[o + 3] = src[o + 3]!;
        }
      }
    }
    return out;
  },
};
